<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

jQuery("span.magicinside").click(function(){
  jQuery("div.productView-desc").toggle();
});

jQuery("span.ccv").click(function(){
  jQuery("div.cuidar-vela").toggle();
});

function includeMailchimpScript() {
    let target = document.querySelector("body");
    let observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutationRecord) {          
            if (mutationRecord.target.className.indexOf('newsletter-show') >= 0) {     
              
                var scriptObj = document.createElement("script");
                scriptObj.type = "text/javascript";              
                scriptObj.innerHTML = `    
                (function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[3]='ADDRESS';ftypes[3]='address';fnames[4]='PHONE';ftypes[4]='phone';fnames[5]='MMERGE5';ftypes[5]='birthday';  /*
                 * Translated default messages for the $ validation plugin.
                 * Locale: ES
                 */
                $.extend($.validator.messages, {
                  required: "Este campo es obligatorio.",
                  remote: "Por favor, rellena este campo.",
                  email: "Por favor, escribe una dirección de correo válida",
                  url: "Por favor, escribe una URL válida.",
                  date: "Por favor, escribe una fecha válida.",
                  dateISO: "Por favor, escribe una fecha (ISO) válida.",
                  number: "Por favor, escribe un número entero válido.",
                  digits: "Por favor, escribe sólo dígitos.",
                  creditcard: "Por favor, escribe un número de tarjeta válido.",
                  equalTo: "Por favor, escribe el mismo valor de nuevo.",
                  accept: "Por favor, escribe un valor con una extensión aceptada.",
                  maxlength: $.validator.format("Por favor, no escribas más de {0} caracteres."),
                  minlength: $.validator.format("Por favor, no escribas menos de {0} caracteres."),
                  rangelength: $.validator.format("Por favor, escribe un valor entre {0} y {1} caracteres."),
                  range: $.validator.format("Por favor, escribe un valor entre {0} y {1}."),
                  max: $.validator.format("Por favor, escribe un valor menor o igual a {0}."),
                  min: $.validator.format("Por favor, escribe un valor mayor o igual a {0}.")
                });}(jQuery));var $mcj = jQuery.noConflict(true);
                `;
                
                
                var scriptMc   = document.createElement("script");
                scriptMc.type  = "text/javascript";
                scriptMc.src   = "//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js";    // use this for linked script
                var targetMc = document.querySelector('body');
                
                document.body.appendChild(scriptMc);
                scriptMc.onload = function() {
                       
                  
                  document.body.appendChild(scriptObj);
                };
                observer.disconnect();
            } else {
                
            };
        })
    });
    
    
    
    // MDN documentation
    // https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver/observe#attributefilter
    observer.observe(target, {
     attributes : true,
     attributeFilter : ['class']
    });

    
    
}

includeMailchimpScript();
function populateIframeMailchimpForm() {
  var myElement = $("#m-sus-form-home").get(0);
  if (document.contains(myElement)) {
    var iframe = document.getElementById('m-sus-form-home');

    var div_el = document.createElement('div');
    
    var content = `
      <!-- Begin Mailchimp Signup Form -->
      <link href="//cdn-images.mailchimp.com/embedcode/classic-071822.css" rel="stylesheet" type="text/css">
      <style type="text/css">
          @import url('https://fonts.googleapis.com/css?family=Montserrat&display=swap');
          @font-face {font-family: "BlackMangoRegular";
            src: url("https://cdn.shopify.com/s/files/1/0398/6692/5209/files/BlackMango-Regular.woff?v=1666721271") format("woff");
          }
          #mc_embed_signup{ width:100%;height:100%;}
          div#mc_embed_signup .asterisk {
              color: white;
          }
          
          /*MAILCHIMP*/
          #mc_embed_signup div.indicates-required {
              display: none;
          }
          
          div#mc_embed_signup {
              background: rgba(0,0,0, 0);
          }
          
          div#mc_embed_signup .helper_text {
              display: none;
          }
          
          div#mc_embed_signup input {
              border: 2px solid #fff;
              border-radius: 30px;
              color:white;
              background: none;
          }
          .mc-custom-response {
              font-family: 'Montserrat';
              font-size: 28px;
              color: #7f7179;
              text-align: center;
              font-weight: 600;
              padding-top: 40px;
          }
          div#mc_embed_signup input::placeholder{
            color:white;
          }
          
          div#mc_embed_signup input#mce-MMERGE5-day, div#mc_embed_signup input#mce-MMERGE5-month{
            border-radius: 0px;
          }
          
          div#mc_embed_signup .mc-field-group label, div#mc_embed_signup .nowrap{
              color: white;
              font-family: Montserrat;
          }
          

          div#mc_embed_signup #mc_embed_signup_scroll >.mc-field-group ~ .mc-field-group{
            width: 60%;
              display: inline-block;
          }
          #mc_embed_signup #mc-embedded-subscribe-form div.mce_inline_error {
              background-color: #eee8e085;
              border-radius: 25px;
          }          
          
          div#mc_embed_signup #mc_embed_signup_scroll >.mc-field-group.size1of2 {
              float: right;
              width: 38% ;
            
          }
          #mc_embed_signup .datefield .dayfield input, #mc_embed_signup .datefield .monthfield input {
              width: 50px;
              padding: 7px 0px;
          }
          div#mc_embed_signup input#mce-MMERGE5-day, div#mc_embed_signup input#mce-MMERGE5-month {
              border-radius: 25px;
          }
          #mc_embed_signup .datefield, #mc_embed_signup .phonefield-us {
              padding: 0px;
          }
          div#mc_embed_signup .button {
              clear: both;
              background-color: #eee8e0;
              border: 0 none;
              border-radius: 4px;
              transition: all 0.23s ease-in-out 0s;
              color: #231f20;
              cursor: pointer;
              display: inline-block;
              font-family:BlackMangoRegular;
              font-size: 15px;
              font-weight: normal;
              height: 40px;
              line-height: 32px;
              margin: 0 5px 10px 0;
              padding: 0 22px;
              text-align: center;
              text-decoration: none;
              vertical-align: top;
              white-space: nowrap;
              font-size: 18px;
              font-weight: bold;
              border-radius: 30px;
              text-transform: initial;
              padding: 0px 45px;
              
          }
          #mc_embed_signup .size1of2 {
    
              margin-right: 0px;
          }
          div#mc_embed_signup .button:hover{
            
              background-color: #231F20;
              
              transition: all 0.23s ease-in-out 0s;
              color: #ffffff;
              cursor: pointer;
              
          }
          
          div#mc_embed_signup div#mce-responses {
              float: left;
              padding: 0em;
              overflow: hidden;
              width: 100%;
              margin: 0 0%;
              clear: both;
          }
          
          div#mc_embed_signup div.response {
              margin: 1em 0;
              padding: 0;
              font-weight: bold;
              float: left;
              top: -1.5em;
              z-index: 1;
              width: 80%;
          }
          #mc_embed_signup #mc-embedded-subscribe-form div.mce_inline_error {
            font-family: Montserrat;
          }
          /*MAILCHIMP*/
          /* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
             We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
      </style>
      <div id="mc_embed_signup">
          <form action="https://brujashops.us5.list-manage.com/subscribe/post?u=5763fe473e3301a9d6a96868e&amp;id=5c9564c65c&amp;f_id=000061e9f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
              <div id="mc_embed_signup_scroll">
              
              <div class="indicates-required"><span class="asterisk">*</span> indicates required</div>
      <div class="mc-field-group">
      	<label for="mce-EMAIL">Email  <span class="asterisk">*</span>
      </label>
      	<input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL" required>
      	<span id="mce-EMAIL-HELPERTEXT" class="helper_text"></span>
      </div>
      <div class="mc-field-group">
      	<label for="mce-FNAME">Nombre  <span class="asterisk">*</span>
      </label>
      	<input type="text" value="" name="FNAME" class="required" id="mce-FNAME" required>
      	<span id="mce-FNAME-HELPERTEXT" class="helper_text"></span>
      </div>
      <div class="mc-field-group size1of2">
      	<label for="mce-MMERGE5-month">Cumpleaños  <span class="asterisk">*</span>
      </label>
      	<div class="datefield">
      		<span class="subfield dayfield">
      			<input class="birthday required" type="text" pattern="[0-9]*" value="" placeholder="DD" size="2" maxlength="2" name="MMERGE5[day]" id="mce-MMERGE5-day" required>
      		</span> / 
              <span class="subfield monthfield">
      			<input class="birthday required" type="text" pattern="[0-9]*" value="" placeholder="MM" size="2" maxlength="2" name="MMERGE5[month]" id="mce-MMERGE5-month" required>
      		</span> 
      		<span class="small-meta nowrap">( dd / mm )</span>
      	</div>
      	<span id="mce-MMERGE5-HELPERTEXT" class="helper_text"></span>
      </div><div hidden="true"><input type="hidden" name="tags" value="2134841,4059499"></div>
      	<div id="mce-responses" class="clear">
      		<div class="response" id="mce-error-response" style="display:none"></div>
      		<div class="response" id="mce-success-response" style="display:none"></div>
      	</div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
          <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_5763fe473e3301a9d6a96868e_5c9564c65c" tabindex="-1" value=""></div>
          <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button"></div>
          </div>
      </form>
      </div>   
      
      <!--End mc_embed_signup-->

    `;
    var scriptObj = document.createElement("script");
    scriptObj.type = "text/javascript";
  
    scriptObj.innerHTML = `
    function createMutationObserver(){
    var target = document.querySelector('body'),

        config = {
            attributes            : true,
            attributeOldValue     : false,
            characterData         : true,
            characterDataOldValue : false,
            childList             : true,
            subtree               : true
        },

        observer = new MutationObserver(function(mutations) {
            var formTarget = document.querySelector('form').offsetHeight;
            //console.log(document.querySelector('body').offsetHeight,formTarget, mutations );
            parent.postMessage({
              event_id: 'iframeResize',
              px: formTarget + 29,     
            });
   
        });

    console.log('Setup MutationObserver');
    observer.observe(target, config);
    }
    
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    
    if (MutationObserver){
        createMutationObserver();
    }
    (function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[3]='ADDRESS';ftypes[3]='address';fnames[4]='PHONE';ftypes[4]='phone';fnames[5]='MMERGE5';ftypes[5]='birthday';  /*
     * Translated default messages for the $ validation plugin.
     * Locale: ES
     */
    $.extend($.validator.messages, {
      required: "Este campo es obligatorio.",
      remote: "Por favor, rellena este campo.",
      email: "Por favor, escribe una dirección de correo válida",
      url: "Por favor, escribe una URL válida.",
      date: "Por favor, escribe una fecha válida.",
      dateISO: "Por favor, escribe una fecha (ISO) válida.",
      number: "Por favor, escribe un número entero válido.",
      digits: "Por favor, escribe sólo dígitos.",
      creditcard: "Por favor, escribe un número de tarjeta válido.",
      equalTo: "Por favor, escribe el mismo valor de nuevo.",
      accept: "Por favor, escribe un valor con una extensión aceptada.",
      maxlength: $.validator.format("Por favor, no escribas más de {0} caracteres."),
      minlength: $.validator.format("Por favor, no escribas menos de {0} caracteres."),
      rangelength: $.validator.format("Por favor, escribe un valor entre {0} y {1} caracteres."),
      range: $.validator.format("Por favor, escribe un valor entre {0} y {1}."),
      max: $.validator.format("Por favor, escribe un valor menor o igual a {0}."),
      min: $.validator.format("Por favor, escribe un valor mayor o igual a {0}.")
    });}(jQuery));var $mcj = jQuery.noConflict(true);


    // select the target node
    var targetResponse = document.getElementById('mce-success-response');
    console.log('popup response targetResponse',targetResponse );
    // create an observer instance
    var observerResponse = new MutationObserver(function(mutations) {
      console.log('popup response mutation',mutations );
      mutations.forEach(function(mutation) {
        if (targetResponse.innerHTML === "Thank you for subscribing!") {
          
          $( "#mc_embed_signup_scroll" ).html('<div class="mc-custom-response">¡Gracias por suscribirte!</div>');
        }
      });
    });
    
    // configuration of the observer:
    var config = { attributes: true, childList: true, characterData: true };
    
    // pass in the target node, as well as the observer options
    observerResponse.observe(targetResponse, config);
    `;
    
    
    var script   = document.createElement("script");
    script.type  = "text/javascript";
    script.src   = "//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js";    // use this for linked script
    script.onload = function() {
      console.log("Script mc-validate is loaded.");      
      iframe.contentWindow.document.body.appendChild(scriptObj);
    };
    div_el.innerHTML = content;

    
    var mcStyle   = document.createElement("style");
    mcStyle.type  = "text/css";
    mcStyle.src   = "https://cdn-images.mailchimp.com/embedcode/classic-071822.css";    // use this for linked script
    
    var scriptJquery   = document.createElement("script");
    scriptJquery.type  = "text/javascript";
    scriptJquery.src   = "https://ajax.googleapis.com/ajax/libs/jquery/3.6.1/jquery.min.js";    // use this for linked script
    scriptJquery.onload = function() {
      console.log("Script jquery is loaded.");
      iframe.contentWindow.document.body.appendChild(div_el);    
      iframe.contentWindow.document.body.appendChild(script);
      
    };
    
    
    
    
    iframe.contentWindow.document.getElementsByTagName('head')[0].appendChild(scriptJquery);
    //iframe.contentWindow.document.body.appendChild(mcStyle);
    //console.log('#1', $("#m-sus-form-home").contents().find("form").outerHeight(), $("#m-sus-form-home").contents().find("form").height());
    //$("#m-sus-form-home").height( $("#m-sus-form-home").contents().find("form").outerHeight() + 30);
    
    //console.log('#2');
    
    
  }
}
function receiveMessage(event)  { 
      if(event.data.hasOwnProperty("event_id")) {
        console.log('iframe message', event.data);
        resizeIframe(event.data.px);
      }
      
}
    
if ('addEventListener' in window){
    window.addEventListener('message', receiveMessage, false);
    
} else if ('attachEvent' in window){ //IE
    window.attachEvent('onmessage', receiveMessage);
}

function resizeIframe(hg) {
  $("#m-sus-form-home").height( hg);
}


var observer = new MutationObserver(function(mutations) {
  var myElement = $("#dummy-chat-button-iframe").get(0);
  
  //console.log("mutations", myElement);
   if (document.contains(myElement)) {
      //console.log("It's in the DOM!");
     setTimeout(function(){ 
        iframeWork();
         
        
      }, 100);
     observer.disconnect();
    }
    
});

observer.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});



var observer2 = new MutationObserver(function(mutations) {
  
  var myElement2 = $("#shopify-chat").get(0);
  //console.log("mutations 2", myElement2);
   
    if (document.contains(myElement2)) {
        //console.log("2 is in the DOM!");
       setTimeout(function(){ 
        iframeWork2();
         
        
        }, 500);
      observer2.disconnect();
    }
});

//observer2.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});




function iframeWork() {
  


  document.getElementById("dummy-chat-button-iframe").contentDocument.body.style.fontFamily = "BlackMangoRegular";
  
  //console.log("Existe DUMMY CHAT1.");
  
  
  var chatFrame = document.getElementById("dummy-chat-button-iframe");
  
  
  const new_style_element = document.createElement("style");
  new_style_element.textContent = `@font-face {font-family: "BlackMangoRegular";
    src: url("https://cdn.shopify.com/s/files/1/0398/6692/5209/files/BlackMango-Regular.woff?v=1666721271") format("woff");}
    
    @font-face {font-family: "Aerotis";
    src: url("https://cdn.shopify.com/s/files/1/0398/6692/5209/files/AerotisS.woff?v=1666723983") format("woff");}
    button#dummy-chat-button.chat-toggle--text-button {
      max-width: unset;
      margin:auto;
    }
    
    #dummy-chat-button-iframe{
      z-index: 999 !important;
    }
    
    .chat-title {
      max-width: unset;
      color: #7C615A;
      font-family: BlackMangoRegular;
      font-size: 18px;
    }
    `;
  chatFrame.contentDocument.head.appendChild(new_style_element);
  //console.log("loaded font");

  
  var scriptObj = document.createElement("script");
  scriptObj.type = "text/javascript";
  
  scriptObj.innerHTML = `
    
    var observerInner = new MutationObserver(function(mutations) {
    
      
      console.log("inner mutations", mutations);
      setTimeout(function(){ 
        var butElement = document.getElementById('dummy-chat-button');
        console.log("inner mutations", butElement, document); 
        if (document.contains(butElement)) {
          console.log("dummy-chat-button It's in the DOM!");
          innerIframeWork();
          observerInner.disconnect();
        }
      }, 50);
       
    });
    
    observerInner.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});

    
    function innerIframeWork() { 
      
      console.log('script iframe');
      
      var openButton = document.getElementById("dummy-chat-button");
      openButton.addEventListener('click', function() { 
        console.log('clicked open button');
      }, false);
      
    }


    
  `;
  
  chatFrame.contentDocument.head.appendChild(scriptObj);

  //console.log("loaded script");
  
  /*jQuery("#dummy-chat-button-iframe").css("width", "auto");*/

}
function iframeWork2() {
  
  document.getElementById("ShopifyChat").contentDocument.body.style.fontFamily = "BlackMangoRegular";
   
  var chatFrame = document.getElementById("ShopifyChat");
    
  const new_style_element = document.createElement("style");
  new_style_element.textContent = `@font-face {font-family: "BlackMangoRegular";
    src: url("https://cdn.shopify.com/s/files/1/0398/6692/5209/files/BlackMango-Regular.woff?v=1666721271") format("woff");}
    
    @font-face {font-family: "Aerotis";
    src: url("https://cdn.shopify.com/s/files/1/0398/6692/5209/files/AerotisS.woff?v=1666723983") format("woff");}
    button.chat-toggle.chat-toggle--text-button {
      max-width: unset;
      margin:auto;
    }
    button.chat-toggle.chat-toggle--text-button .chat-title {
      max-width: unset;
      color: #7C615A;
      font-family: BlackMangoRegular;
      font-size: 18px;
    }
    .interstitial-view__welcome .store-info-heading h2 {
      color: #7C615A;
      
    }
    .interstitial-view__welcome .store-info p {
    color: #7C615A;
  
  }
  .chat-app button.outline-button p{
    color: #7C615A;
  }
  .chat-app button.outline-button path{
    color: #7C615A;
  }
    `;
  chatFrame.contentDocument.head.appendChild(new_style_element);
  //console.log("loaded font 2");

  
  var scriptObj = document.createElement("script");
  scriptObj.type = "text/javascript";
  
  scriptObj.innerHTML = `
    
    var observerInner = new MutationObserver(function(mutations) {
    
      
      
      setTimeout(function(){ 
        var butElement = document.getElementById('dummy-chat-button');
        
        if (document.contains(butElement)) {
          
          innerIframeWork();
          observerInner.disconnect();
        }
      }, 50);
       
    });
    
    observerInner.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});

    
    function innerIframeWork() { 
      
      
      
      var openButton = document.getElementById("dummy-chat-button");
      openButton.addEventListener('click', function() { 
        
      }, false);
      
    }


    
  `;
  
  chatFrame.contentDocument.head.appendChild(scriptObj);

  //console.log("loaded script 2");
  
  jQuery("#ShopifyChat").addClass("secondChatIframe");

}




jQuery( document ).ready(function($) {  
  let videoElement = $( ".video-container source" );
  
  if(videoElement.length > 0 ) {
    $( window ).one("scroll", function() {     
        
        populateIframeMailchimpForm();
        var sourceFile = 'https://cdn.shopify.com/videos/c/o/v/6b26def8757b41d8afb0085db60c3060.mp4';
        videoElement.attr("src", sourceFile);
        var video = videoElement.parent();        
        video[0].load();
        video[0].play(); 
        
      
      
     
    });
  }
  
  
  
  const targetNode = document.querySelector('.swiper-nosotros');
  if (document.contains(targetNode)) {
  const swiper = new Swiper('.swiper-nosotros', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  slidesPerView: 1,
  spaceBetween: 30,
  speed:1000,
  centeredSlides: true,
  autoHeight: true,
  pauseOnMouseEnter: false,
  autoplay: {
    delay: 7000,
  },
  disableOnInteraction: true ,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  
  
   
   
  });
}

  /*
    const swiper = new Swiper('.swiper', {
      // Optional parameters
      direction: 'vertical',
      loop: true,
    
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },
    
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    
      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    });
  */
});


// Select the node that will be observed for mutations
const targetNode = document.querySelector('bundle-builder-bundle-v1');
if (document.contains(targetNode)) {
  initMagicBox();
}

function initMagicBox() {
  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: true, subtree: true, };
  
  // Callback function to execute when mutations are observed
  
  const callback = (mutationList, observer) => {
    console.log(mutationList);
    var myElement = $(".bundle-builder-app--bundle--section-description").get(0);
    if (document.contains(myElement)) {
        console.log("bundle-builder-app It's in the DOM!");
        $(".new-desc").remove();
        $(".bundle-builder-app--bundle--section-description").addClass('hidden');
        var decoded = $(".bundle-builder-app--bundle--section-description").text();
        newEl = '<div class="new-desc"></div>';
      
        $(".bundle-builder-app--bundle--section-description").after(newEl);
        $(".new-desc").html(decoded);
        observer.disconnect();
        setTimeout(() => {
          console.log('reconnect');
          observer.observe(targetNode, config);
        }, "200")
    }
    
    
  };
  
  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);
  
  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);

}


function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
  var startTimeInMs = Date.now();
  (function loopSearch() {
    if (document.querySelector(selector) != null) {
      callback();
      return;
    }
    else {
      setTimeout(function () {
        if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
          return;
        loopSearch();
      }, checkFrequencyInMs);
    }
  })();
}

